export interface RuntimeConfig {
    ENVIRONMENT: string;
    API_URL: string;
    DOMAIN_EMAIL: string;
    GIT_TAG: string;
}

declare global {
    interface Window {
        __APP_CONFIG__?: RuntimeConfig;
    }
}

if (!window.__APP_CONFIG__) {
    console.warn("Runtime config /config.js was not loaded. No env vars loaded");
}

export const runtimeConfig: RuntimeConfig = {
    ENVIRONMENT: window.__APP_CONFIG__?.ENVIRONMENT ?? "",
    API_URL: window.__APP_CONFIG__?.API_URL ?? "",
    DOMAIN_EMAIL: window.__APP_CONFIG__?.DOMAIN_EMAIL ?? "",
    GIT_TAG: window.__APP_CONFIG__?.GIT_TAG ?? "",
};